"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = exports.themeOptions = void 0;
const styles_1 = require("@mui/material/styles");
exports.themeOptions = {
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                "*": {
                    boxSizing: "border-box",
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: "none",
                },
            },
        },
    },
    palette: {
        mode: "light",
        primary: {
            main: "#45b7d1",
            contrastText: "#fff",
        },
        secondary: {
            main: "#ff6b6b",
            contrastText: "#fff",
        },
        tertiary: {
            main: "#764ba2",
            contrastText: "#fff",
        },
        text: {
            primary: "#333",
            secondary: "#666",
        },
        custom: {
            sentenceHighlightBg: "rgb(255, 255, 0, 0.5)",
            wordHighlightBg: "#9cec6a",
            orange: "#fda085",
        },
        gradient: {
            primary: "linear-gradient(45deg, #ff6b6b, #4ecdc4, #45b7d1, #96ceb4)",
            card1: "linear-gradient(135deg, #ff6b6b, #4ecdc4)",
            card2: "linear-gradient(135deg, #f6d365, #fda085)",
            card3: "linear-gradient(135deg, #667eea, #764ba2)",
            card4: "linear-gradient(135deg, #ff9a9e, #fecfef)",
            homeBackground: "linear-gradient(135deg, #ff9a9e 0%, #fecfef 50%, #fecfef 100%);",
        },
    },
};
exports.theme = (0, styles_1.createTheme)(exports.themeOptions);
